import { FC, ReactElement } from 'react';
import { useCompositeBalance } from '../../../store/compositeSelectors/useCompositeBalance';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';
import { useIsLandscape, useIsPortrait } from '@pp/core/src/styles/hooks/media';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { CurrencyConnected } from '@pp/core/src/components/currency/CurrencyConnected';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';
import { useBonusBalanceConfig } from '@pp/core/src/store/compositeSelectors/useBonusBalanceConfig';
import {useNetPositionConnected} from '@pp/core/src/hooks/useNetPositionConnected';

import styles from './BalanceMidSection.module.css';

export const BalanceMidSection: FC = (): ReactElement => {
    const isPortrait = useIsPortrait();
    const isLandScape = useIsLandscape();
    const tableConfig = useConfigSlice.tableConfig();
    const compliance = useConfigSlice.compliance();

    const balance = useCompositeBalance();

    const alignBottomMods = useModifiers(styles, 'alignBottom', {
        portrait: isPortrait,
        landscape: isLandScape,
    });

    const jurisdiction = useConfigSlice.playerConfig()?.jurisdiction;
    const displayBonusBalance = (useBonusBalanceConfig() || jurisdiction === 'X1');
    const net =  useNetPositionConnected();

    return (
        <div className={`${styles.BalanceMidSection} ${alignBottomMods}`}>
            {isPortrait && net !== undefined &&
                <div className={styles.portraitText}>
                    <span className={styles.textLeft}><L10nText tk="NET_POSITION" /></span> &nbsp;
                    <span className={styles.textRight}><CurrencyConnected value={net} /></span>
                </div>}

            {isLandScape && compliance?.showSessionId &&
                <div className={styles.landScapeIt}>
                    ID-P: {tableConfig?.aamsTicket} ID-S: {tableConfig?.aamsSessionId}
                </div>}

            {isLandScape && !displayBonusBalance && net !== undefined &&
                <div className={styles.landScapeNetPos}>
                    <span className={styles.textLeft}><L10nText tk="NET_POSITION" /></span> &nbsp;
                    <span className={styles.textRight}><CurrencyConnected value={net} /></span>
                </div>}

            {isLandScape &&
                <div className={styles.landscapeUk}>
                    {displayBonusBalance && net !== undefined &&
                        <div className={styles.landscapeUkNetPos}>
                            <span className={styles.textLeft}><L10nText tk="NET_POSITION" /></span> &nbsp;
                            <span className={styles.textRight}><CurrencyConnected value={net} /></span>
                        </div>}

                    {displayBonusBalance && balance &&
                        <div className={styles.landscapeUkBonus}>
                            <span><L10nText tk="BONUS" /></span> &nbsp;
                            <span><CurrencyConnected value={balance?.bonus} /></span>
                        </div>}
                </div>}
        </div>
    );
};
